import React from "react";
import axios from "axios";

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import * as Constants from "../../consts/Constants.js";

export default function Image({ url, containerProps, imgProps, onClick}) {

  const [blobUrl, setBlobUrl] = React.useState(null);

  const getImage = () => {
    axios.get(url, { responseType: 'blob' }).then((response) => {
        let blob = response.data;
        let newBlobUrl = URL.createObjectURL(blob);
        setBlobUrl(newBlobUrl);
      }
    );
  }

  React.useEffect(() => () => { // En el unmount borro la imagen para liberar memoria
    let prevBobUrl = blobUrl;
    if (prevBobUrl != null) {
      setBlobUrl(null);
      URL.revokeObjectURL(prevBobUrl);
    }
  }, []);

  React.useEffect(() => { // Al cambiar de url
    let prevBobUrl = blobUrl; // Borro la imagen previa para liberar memoria
    if (prevBobUrl != null) {
      setBlobUrl(null);
      URL.revokeObjectURL(prevBobUrl);
    }
    getImage(); // Cargo la imagen nueva
  }, [url]);

  React.useEffect(() => {
    getImage(); // En el mount cargo la imagen
  }, []);

  return (
    <div {...containerProps} onClick={ () => { if (onClick) onClick(blobUrl) }  }>
      {
        (blobUrl != null) ? (
          <img src={blobUrl} loading="lazy" {...imgProps} />
        ) : (
          <div {...imgProps}>
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="100%"> 
                <CircularProgress size={24} style={{color:Constants.COLOR_PRIMARY}} color="inherit" />
              </Box>
          </div>
        )
      }
    </div>
  );
}
